import React, { Component } from 'react'
import { connect } from 'react-redux'
import yn from 'yn'

import BkFlowPolicyViewer from './layouts/BkFlowPolicyViewer'
import BkFlowMaterialLoader from '../elements/BkFlowMaterialLoader'

import '../../styles/css/components/policies/bk-flow-policy-viewer.css'

import _ from 'lodash'

class BkFlowPolicies extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const {
			configData,
			hotelDescriptiveInfoData,
			propertyPoliciesData,
			roomRateDetailsLoading
		} = this.props

		let policies = [],
				renderPolicyViewers = []

		// Render hotel policies data via OTAHotelDescriptive info or roomRateDetails request
		if (
			process.env.REACT_APP_COMPONENT_BASE_CRS_DATA &&
			!yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
			!_.isEmpty(hotelDescriptiveInfoData) &&
			!_.isEmpty(hotelDescriptiveInfoData.policies)
		) {
			for (let policyKey in hotelDescriptiveInfoData.policies) {
				if (policyKey === 'cancelPolicy') {
					if (
						hotelDescriptiveInfoData.policies[policyKey].cancelPenalty &&
						hotelDescriptiveInfoData.policies[policyKey].cancelPenalty.penaltyDescription &&
						hotelDescriptiveInfoData.policies[policyKey].cancelPenalty.penaltyDescription.text
					) {
						policies.push(
							{
								title: 'Cancellation Policy',
								content  : hotelDescriptiveInfoData.policies[policyKey].cancelPenalty.penaltyDescription.text
							}
						)
					}
				} else if (policyKey === 'paymentPolicy'){
					if (
						hotelDescriptiveInfoData.policies[policyKey].requiredPayment &&
						hotelDescriptiveInfoData.policies[policyKey].requiredPayment.paymentDescription &&
						hotelDescriptiveInfoData.policies[policyKey].requiredPayment.paymentDescription.text
					) {
						policies.push(
							{
								title: 'Payment Policy',
								content: hotelDescriptiveInfoData.policies[policyKey].requiredPayment.paymentDescription.text
							}
						)
					}
				}
			}
		} else if (
			!_.isEmpty(propertyPoliciesData)
		) {
			policies = propertyPoliciesData
		}

		if (!_.isEmpty(policies)) {
			renderPolicyViewers.push(
				<BkFlowPolicyViewer
					key={'hotel-policies'}
					configData={configData}
					policies={policies}
				/>
			)
		}

		return (
			roomRateDetailsLoading ?
				<BkFlowMaterialLoader
					parentClasses='u-txt-center'
					size={30}
				/>
			:
				renderPolicyViewers
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		hotelDescriptiveInfoData: state.hotelDescriptiveInfo.hotelInfo,
		propertyPoliciesData: state.availabilityData.propertyPolicies,
		roomRateDetailsLoading: state.roomRateDetailsData.loading
	}
}

export default connect(mapStateToProps, null)(BkFlowPolicies)


// WEBPACK FOOTER //
// ./src/components/policies/BkFlowPolicies.js